import { Observable } from 'rxjs';
import { CountryApiData } from '../models/Country.model';

export abstract class CountryRepository {
    abstract getCountries(language: string): Observable<CountryApiData>;
}
